import { Link } from "react-router-dom";
import { toAbsoluteUrl } from "@/utils";

const AccountVerified = () => {
  return (
    <div className="card max-w-[440px] w-full">
      <div className="card-body p-10">
        <div className="flex justify-center mb-5">
          <img
            src={toAbsoluteUrl("/media/illustrations/32.svg")}
            className="dark:hidden max-h-[180px]"
            alt="Account verified successfully illustration"
          />
          <img
            src={toAbsoluteUrl("/media/illustrations/32-dark.svg")}
            className="light:hidden max-h-[180px]"
            alt="Account verified successfully illustration"
          />
        </div>

        <h3 className="text-lg font-medium text-gray-900 text-center mb-4">
          Account Verified Successfully
        </h3>
        <div className="text-2sm text-center text-gray-700 mb-7.5">
          Your account has been successfully verified.
          <br />
          You can now access all features of your account securely.
        </div>

        <div className="flex justify-center">
          <Link to="/auth/login" className="btn btn-primary">
            Sign in
          </Link>
        </div>
      </div>
    </div>
  );
};

export { AccountVerified };
